import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProfilesList from "../Components/ProfilesList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import "./Profiles.css";

function Profiles() {
  const [isLoading, setIsLoading] = useState(true);
  const [profiles, setProfiles] = useState([]);
  const [count, setCount] = useState(0);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/profiles/organization/${state.organization}`,
        data: {
          language: state.language,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setProfiles(response.data.profiles);
      setCount(response.data.count);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.token, state.language]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="profiles-header">
            <h2>
              {t("Perfiles.Titulo")} ({count})
            </h2>
          </Col>
          <Col lg={1} className="right profiles-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/profiles/new`}>
                  <FontAwesomeIcon icon={faPlus} /> {t("Perfiles.NuevoPerfil")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {profiles.length === 0 ? (
            <Col className="empty-profiles center">
              <h5>{t("Perfiles.SinPerfiles")}</h5>
            </Col>
          ) : (
            <ProfilesList profiles={profiles} language={state.language} />
          )}
        </Row>
      </Container>
    );
  }
}

export default Profiles;
